import { render } from "./explore-schools.vue?vue&type=template&id=ba07e574"
import script from "./explore-schools.vue?vue&type=script&lang=js"
export * from "./explore-schools.vue?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__